import { useState } from "react";

export default function useOutletController() {
  const [sheetContainer, setSheetContainer] = useState<JSX.Element | undefined>();
  return {
    sheetContainer,
    setSheetContainer
  };
}
